import { render, staticRenderFns } from "./notificationpage.vue?vue&type=template&id=9421ed02&scoped=true&"
import script from "./notificationpage.vue?vue&type=script&lang=js&"
export * from "./notificationpage.vue?vue&type=script&lang=js&"
import style0 from "./notificationpage.vue?vue&type=style&index=0&id=9421ed02&prod&scoped=true&lang=css&"
import style1 from "./notificationpage.vue?vue&type=style&index=1&id=9421ed02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9421ed02",
  null
  
)

export default component.exports